import React from 'react';
import { Box, HStack, Text } from '@chakra-ui/react';

// iOS-style underline CTA with arrow → label and a thin underline
// Props:
// - text: string (label)
// - onClick: function (click handler)
// - color: text/arrow color (default 'white')
// - underlineColor: underline color (default 'whiteAlpha.900')
// - align: 'left' | 'center' | 'right' (default 'left')
// - gap: spacing between arrow and text
// - fontSize: Chakra fontSize token
export default function UnderlineCTA({
  text = 'On vous en dit plus ?',
  onClick,
  color = 'white',
  underlineColor = 'whiteAlpha.900',
  align = 'left',
  gap = 3,
  fontSize = { base: '10px', md: '14px' },
}) {
  return (
    <Box
      as="button"
      onClick={onClick}
      textAlign={align}
      bg="transparent"
      _hover={{}}
      _focus={{ outline: 'none' }}
    >
      <HStack
        spacing={gap}
        align="center"
        justify={align === 'left' ? 'flex-start' : align === 'right' ? 'flex-end' : 'center'}
        color={color}
      >
        <Text fontSize={fontSize} lineHeight="1.2">→</Text>
        <Text fontSize={fontSize} lineHeight="1.2" fontWeight={600}>{text}</Text>
      </HStack>
      <Box
        mt={2}
        h="2px"
        w="100%"
        bg={underlineColor}
        borderRadius="full"
        opacity={0.9}
      />
    </Box>
  );
}


